import "./styles.css";

export default function TypingIndicator({ className = "" }) {
  return (
    <div
      className={`flex items-center gap-1.5 ${className}`}
      aria-label="Assistant is typing"
    >
      <span className="typing-dot" />
      <span className="typing-dot" />
      <span className="typing-dot" />
    </div>
  );
}
